/*@begin-app-target*/import { AppRoutes } from '../../app-browse/app-routes';/*@end-app-target*/
import { IBwjBillboardProps } from "../../framework/components/bwj-billboard";
import { BwjButtonType } from "../../framework/components/bwj-button";
import { useNavigator } from "../../framework/services/navigation";

export const useStandardResourceNotFoundState = () => {
  const navigator = useNavigator();

  const props: IBwjBillboardProps = {
    icon: 'SearchIssue',
    message: 'Sorry - we could not find what you are looking for, or it is no longer available',
    buttons: [{
      buttonStyle: BwjButtonType.PrimaryStandard,
      text: 'Return to home view',
      onClick: () => navigator.goTo(AppRoutes.home.url()),
    }],
  };

  return props;
}